import React from "react";
import { SkeletonText } from "../../UI/DesignStandards";
import Breadcrumb from "../../Breadcrumb/Breadcrumb";

const SignupEditSkeleton = () => (
  <div className="min-h-screen bg-brand-cream">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
      <div className="flex justify-center">
        <Breadcrumb
          items={[
            { label: "My Signups", path: "/signup/dashboard" },
            { label: "Signup details" },
          ]}
        />
      </div>
      <div className="card-board overflow-hidden">
        <div className="bg-brand-charcoal px-6 py-4">
          <SkeletonText size="sm" width="40" className="bg-brand-mist/30" />
          <SkeletonText size="lg" width="56" className="bg-brand-mist/20 mt-2" />
        </div>
        <div className="p-5 sm:p-6 space-y-4">
          <SkeletonText size="sm" width="1/2" />
          <SkeletonText size="sm" width="2/3" />
          <SkeletonText size="sm" width="1/3" />
          <SkeletonText size="lg" width="1/4" className="mt-4" />
          <SkeletonText size="sm" width="1/2" />
          <SkeletonText size="sm" width="2/3" />
        </div>
      </div>
    </div>
  </div>
);

export default SignupEditSkeleton;
